/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Land_Title_Showcase_FocusingInputs */

const en_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Focusing`)
};

const ar_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · أثناء التركيز`)
};

const de_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Beim Fokussieren`)
};

const es_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Durante la concentración`)
};

const fr_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · En pleine concentration`)
};

const it_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Durante la concentrazione`)
};

const ja_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 集中中`)
};

const ko_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 집중 중`)
};

const pt_br_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Durante o foco`)
};

const ru_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Во время концентрации`)
};

const th_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · ขณะมีสมาธิ`)
};

const tr_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Odaklanırken`)
};

const zh_cn_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 专注中`)
};

const zh_tw_shop_land_title_showcase_focusing = /** @type {(inputs: Shop_Land_Title_Showcase_FocusingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 專注中`)
};

/**
* | output |
* | --- |
* | "· Focusing" |
*
* @param {Shop_Land_Title_Showcase_FocusingInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const shop_land_title_showcase_focusing = /** @type {((inputs?: Shop_Land_Title_Showcase_FocusingInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Land_Title_Showcase_FocusingInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shop_land_title_showcase_focusing(inputs)
	if (locale === "ar") return ar_shop_land_title_showcase_focusing(inputs)
	if (locale === "de") return de_shop_land_title_showcase_focusing(inputs)
	if (locale === "es") return es_shop_land_title_showcase_focusing(inputs)
	if (locale === "fr") return fr_shop_land_title_showcase_focusing(inputs)
	if (locale === "it") return it_shop_land_title_showcase_focusing(inputs)
	if (locale === "ja") return ja_shop_land_title_showcase_focusing(inputs)
	if (locale === "ko") return ko_shop_land_title_showcase_focusing(inputs)
	if (locale === "pt_br") return pt_br_shop_land_title_showcase_focusing(inputs)
	if (locale === "ru") return ru_shop_land_title_showcase_focusing(inputs)
	if (locale === "th") return th_shop_land_title_showcase_focusing(inputs)
	if (locale === "tr") return tr_shop_land_title_showcase_focusing(inputs)
	if (locale === "zh_cn") return zh_cn_shop_land_title_showcase_focusing(inputs)
	return zh_tw_shop_land_title_showcase_focusing(inputs)
});